<script lang="ts">
  import { getTimeZone } from "../data/clock";
  import { ensureDate } from "../support/dates";
  import { settings } from "../data/settings";
  import { getLocale } from "../domain/locale";
  import Locale from "./locale.svelte";

  export let time: Date;
  export let timeZone = getTimeZone();
  export let overrides = {};
  export let label = "timestamp.label";

  $: formatter = new Intl.DateTimeFormat(getLocale(), {
    hour: "numeric",
    minute: "2-digit",
    timeZone: $timeZone
  });

  $: amPm = { ...$settings, ...overrides }.amPm;

  function localTime(date: Date) {
    return formatter
      .format(ensureDate(date))
      .toLowerCase()
      .replace(/\s(am|pm)/, amPm ? "$1" : "");
  }

  $: date = ensureDate(time);
</script>

<time datetime={date.toISOString()}>
  <Locale {label} vars={{ time: localTime(date) }} />
</time>
